import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'fullScreenToggle', 'completedToggle' ]

  fullScreen = false;

  connect() {
    // console.log("Hello, FTP Controller here!", this.element)

    const storedFullScreenValue = JSON.parse(localStorage.getItem('ftp-fullscreen'));
    const storedHideCompletedValue = JSON.parse(localStorage.getItem('ftp-hide-completed'));

    // console.log('Stored Fullscreen Value is: ', storedFullScreenValue);
    if (storedFullScreenValue === true) {
      this.makeFullScreen();
    }

    if (storedHideCompletedValue === true) {
      this.hideCompleted();
    }

  }

  hideCompleted() {
    if (!this.completedToggleTarget.checked) {
      this.completedToggleTarget.checked = true;
      this.toggleHideComplete({ target: { checked: true } });
    }
  }

  toggleHideComplete(event) {
    // console.log('toggling completed');

    const new_value = event.target.checked;
    localStorage.setItem('ftp-hide-completed', event.target.checked);

    const params = new URLSearchParams(window.location.search);
    params.set('hide_complete', new_value);

    window.location.search = params.toString();
  }

  makeFullScreen() {
    // console.log('makeFullScreen');

    const sidebar = document.querySelector('#admin-sidebar-container');
    const content = document.querySelector('#admin-content-container');

    sidebar.classList.toggle('d-none');
    content.classList.toggle('col-md-12');

    this.toggleTarget.classList.toggle('d-none');

    this.fullScreen = true;

    localStorage.setItem('ftp-fullscreen', true);
  }

  makeNotFullScreen() {
    // console.log('shrinking screen');

    const sidebar = document.querySelector('#admin-sidebar-container');
    const content = document.querySelector('#admin-content-container');

    sidebar.classList.toggle('d-none');
    content.classList.toggle('col-md-12');

    this.toggleTarget.classList.toggle('d-none');

    this.fullScreen = false;

    localStorage.setItem('ftp-fullscreen', false);
  }

}
